module.exports = __webpack_public_path__ + "static/assets/42f937837c8780e2937172f004ed298c.svg";